<template>
  <CardViewModal @close="close" size="small">
    <template #header-text>
      <span>{{ replaceFlags($t('Translations for %s'), [field.label]) }}</span>
    </template>
    <template #main-content>
      <TabView>
        <TabPanel v-for="(elem, key) in translations" :header="$t(key.toUpperCase())">
          <TextInput v-if="field.type === 'TextInput'" label="Value" :hide-label="true" :allow-translations="false" v-model="translations[key]"/>
          <TextareaInput v-if="field.type === 'TextareaInput'" label="Value" :hide-label="true" :allow-translations="false" v-model="translations[key]"/>
          <EditorInput v-if="field.type === 'EditorInput'" label="Value" :hide-label="true" :allow-translations="false" v-model="translations[key]"/>
        </TabPanel>
      </TabView>
    </template>
    <template #footer-buttons>
      <Button :label="$t('Save')" icon="pi pi-save" class="p-button-primary" iconPos="left" @click="save"/>
    </template>
  </CardViewModal>
</template>

<script>
import {replaceFlags} from '@/js/utils';
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";

export default {
  name: 'TranslationsPopup',
  components: {TabView, TabPanel},
  props: {
    field: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      translations: {}
    };
  },
  mounted() {
    for (let lg of this.$root.$i18n.availableLocales) {
      this.translations[lg] = '';
    }

    if (this.field.translations) {
      this.translations = {...this.translations, ...this.field.translations};
    }
  },
  methods: {
    replaceFlags,
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', this.translations);
    },
  },
};
</script>

<style scoped></style>
